export default __webpack_public_path__ + "static/halloween-a355ce864b0a396cf3d2f4b960e1f0b9.svg";